<template lang="pug">
v-container(class=" tw-overflow-auto tw--mt-8")
  v-row(dense class=" tw-overflow-y-auto tw-max-h-screen")
    v-col(cols="12" md="7" class="mt-7 md:tw-h-full")
      template(v-if="loading")
        v-row
          v-col(cols="8")
            v-row(no-gutters align="center" class="tw-pb-2 w-full")
              v-col(cols="12")
                v-skeleton-loader(type="heading" class="pl-4")
                v-skeleton-loader(type="list-item-three-line" width="100%")
                v-skeleton-loader(type="list-item-two-line" width="100%")
          v-col(cols="4" class="tw-pr-6")
            v-row(no-gutters)
              v-col
                span(class=" tw-text-lg tw-font-bold tw-capitalize") {{ $t('Opportunities.Common.budget') }}
                div(class="tw-pt-2")
                  v-row(no-gutters align="center")
                    v-col(cols="2")
                      v-skeleton-loader(type="text")
                    v-col(cols="stretch mx-1")
                      v-divider
                    v-col(cols="2")
                      v-skeleton-loader(type="text")
            v-row(no-gutters class="pt-4")
              v-col
                div
                  span(class="tw-text-lg tw-font-bold") {{ $t('Opportunities.Common.decisionBy') }}
                div(class="tw-pt-2")
                  v-skeleton-loader(type="text")
      template(v-else)
        v-row(class="tw-pb-4")
          v-col(cols="12" md="8")
            v-row(no-gutters align="center" class="tw-pb-2")
              v-col(cols="auto")
                span(class=" tw-text-lg tw-font-bold") {{ $t('Common.description') }}
            v-row(no-gutters class="pt-2")
              v-col
                div(v-dompurify-html="opportunity.description" class="tw-whitespace-pre-wrap")
          v-col(cols="12" md="4" class="tw-pr-6")
            v-row(v-if="opportunity.budget_min && opportunity.budget_max" no-gutters)
              v-col
                span(class=" tw-text-lg tw-font-bold") {{ $t('Opportunities.Common.budget') }}
                div(class="tw-pt-2")
                  v-row(no-gutters align="center")
                    v-col(cols="auto")
                      span(class=" tw-text-indigo-lighten-1 tw-font-bold ") {{ this.$formatters.formatValue(opportunity.budget_min) }}
                    v-col(cols="stretch mx-1")
                      v-divider
                    v-col(cols="auto")
                      span(class=" tw-text-indigo-lighten-1 tw-font-bold ") {{ this.$formatters.formatValue(opportunity.budget_max) }}

            v-row(v-if="opportunity.expected_close_date" no-gutters class="pt-4")
              v-col
                div
                  span(class="tw-text-lg tw-font-bold") {{ $t('Opportunities.Common.decisionBy') }}
                div(class="tw-pt-2")
                  v-chip(label outlined color=" grey lighten-3")
                    v-icon(small color="grey lighten-1") mdi-calendar
                    span(class="pl-1 tw-text-sm tw-font-bold tw-text-gray-darken-2") {{ this.$moment(opportunity.expected_close_date).format('LL') }}
        v-row(v-if="contacts.length > 0")
          v-col(cols="12")
            kubiqa-goods-edit-contacts-list(:contacts="contacts")
        v-row(v-if="!$vuetify.breakpoint.mobile" class="")
          v-col(class="tw-h-48")

    v-col(cols="12" md="5" class="tw-h-full md:tw-border-l md:tw-border-gray-lighten-2")
      div(class=" tw-flex tw-flex-grow tw-max-h-full tw-h-full tw-pb-4 ")
        v-row(no-gutters class="tw-max-h-full  d-flex flex-row flex-grow-1 ")
          v-col(class=" d-flex flex-column flex-grow-1 overflow-hidden")
            kubiqa-activity
</template>
<script>
export default {
  data() {
    return {
      //loading: false,
    };
  },
  computed: {
    opportunity() {
      return this.$store.getters['opportunities/current_opportunity'];
    },
    contacts() {
      return this.$store.getters['opportunities/contacts/list'];
    },
    loading() {
      return this.$store.getters['opportunities/loading'];
    },
  },
  // mounted() {
  //   this.loading = true;
  //   this.$store
  //     .dispatch('opportunities/view', this.$route.params.id)
  //     .then(() => {
  //       this.loading = false;
  //       this.key++;
  //     })
  //     .catch((error) => {
  //       commit('SET_ERROR', error, { root: true });
  //     });
  // },
};
</script>
